<div class="modal-header-custom">
  <h3>Atestados de Acompanhante</h3>
  <mat-icon class="close-btn" matTooltip="Fechar" (click)="close()">close</mat-icon>
</div>

<div mat-dialog-content>
  <div [formGroup]="modalForm">
    <div formArrayName="companions">

      @for (companion of companionsFormArray.controls; track companion; let i = $index) {
        <div class="row align-items-center companion-form-row"
          [formGroupName]="i">
          <div class="col-12 col-sm-2">
            <mat-form-field appearance="outline" class="input-full-width">
              <mat-label>Dias</mat-label>
              <input matInput type="number" formControlName="daysOff" min="1" max="365">
              @if (getControl(i, 'daysOff').hasError('required')) {
                <mat-error>Obrigatório</mat-error>
              }
              @if (getControl(i, 'daysOff').hasError('min')) {
                <mat-error>Mínimo 1 dia</mat-error>
              }
              @if (getControl(i, 'daysOff').hasError('max')) {
                <mat-error>Máximo 365 dias</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-4">
            <mat-form-field appearance="outline" class="input-full-width">
              <mat-label>CPF do Responsável</mat-label>
              <input matInput type="text" formControlName="companionCpf" mask="000.000.000-00">
              @if (getControl(i, 'companionCpf').hasError('required')) {
                <mat-error>Obrigatório</mat-error>
              }
              @if (getControl(i, 'companionCpf').hasError('cpfInvalid')) {
                <mat-error>CPF inválido</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-5">
            <mat-form-field appearance="outline" class="input-full-width">
              <mat-label>Nome do Acompanhante</mat-label>
              <input matInput type="text" formControlName="companionName" class="input-uppercase">
              @if (getControl(i, 'companionName').hasError('required')) {
                <mat-error>Obrigatório</mat-error>
              }
              @if (getControl(i, 'companionName').hasError('minlength')) {
                <mat-error>Mínimo 3 caracteres</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="col-12 col-sm-1 action-buttons-container">
            <button mat-mini-fab type="button" class="btn-add-companion" (click)="addCompanion()" matTooltip="Adicionar">
              <mat-icon>add</mat-icon>
            </button>
            <button mat-mini-fab type="button" class="btn-remove-companion" (click)="removeCompanion(i)"
              matTooltip="Remover">
              <mat-icon>remove</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<div mat-dialog-actions class="modal-footer-custom">
  <div class="row w-100">
    <div class="col-12 col-md-6">
      <button mat-flat-button type="button" color="accent" class="btn-block" (click)="close()">
        @if (!isLoading) {
          <span>Cancelar</span>
        }
        @if (isLoading) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
    <div class="col-12 col-md-6">
      <button mat-flat-button type="button" color="primary" class="btn-block" (click)="save()" [disabled]="isLoading">
        @if (!isLoading) {
          <span>Confirmar</span>
        }
        @if (isLoading) {
          <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
        }
      </button>
    </div>
  </div>
</div>